import React from 'react';
import { AvGroup, AvInput } from 'availity-reactstrap-validation';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputGroupAddon, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import {
  capitalize,
  parseLocaleNumber,
} from '../../../../utility/util/util.service';

const TableField = ({
  type,
  propertyName,
  object,
  messageId,
  label,
  hidden,
  groupClassName,
  value,
  defaultValue,
  preChildren,
  postChildren,
  onChange,
  isMultiple,
  ...props
}) => {
  const intl = useIntl();
  return (
    <AvGroup className="form-label-group input-group input-group-merge">
      <FormattedMessage
        id={
          isMultiple
            ? 'createMultipleTablePrefixLabel'
            : 'dynamicTableNameField'
        }
      >
        {(placeholder) => (
          <AvInput
            id={propertyName}
            type={type || 'text'}
            name={propertyName}
            value={value ?? object?.[propertyName] ?? defaultValue ?? ''}
            placeholder={intl.formatMessage({
              id: isMultiple
                ? 'createMultipleTablePrefixLabel'
                : 'dynamicTableNameField',
            })}
            hidden={hidden}
            onChange={onChange}
            {...props}
          />
        )}
      </FormattedMessage>
      <Label for={object?.id}>
        <FormattedMessage
          id={
            isMultiple
              ? 'createMultipleTablePrefixLabel'
              : 'dynamicTableNameField'
          }
        />
      </Label>
    </AvGroup>
  );
};

export default TableField;
